import React, { useState, useEffect, useRef } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import styles from './OfferDetailPage.module.css';

export interface DropdownMenuItem {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  show?: boolean;
}

interface ActionDropdownProps {
  label: string;
  icon: React.ReactNode;
  items: DropdownMenuItem[];
}

export function ActionDropdown({ label, icon, items }: ActionDropdownProps): React.JSX.Element | null {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const visibleItems = items.filter((item) => item.show !== false);
  if (visibleItems.length === 0) return null;

  return (
    <div ref={dropdownRef} className={styles.actionDropdownContainer}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={isOpen ? styles.actionDropdownBtnOpen : styles.actionDropdownBtn}
      >
        {icon}
        {label}
        <FaChevronDown
          size={10}
          className={styles.actionDropdownChevron}
          style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0)' }}
        />
      </button>
      {isOpen && (
        <div className={styles.actionDropdownMenu}>
          {visibleItems.map((item, index) => (
            <button
              key={index}
              onClick={() => {
                item.onClick();
                setIsOpen(false);
              }}
              disabled={item.disabled}
              className={item.disabled ? styles.actionDropdownItemDisabled : styles.actionDropdownItem}
              style={{
                borderBottom: index < visibleItems.length - 1 ? '1px solid #f0f0f0' : 'none',
              }}
            >
              <span
                className={styles.actionDropdownItemIcon}
                style={{ color: item.disabled ? '#ccc' : '#666' }}
              >
                {item.icon}
              </span>
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
